import { type ReactNode } from 'react';
import { EditorContext, type EditorContextValue } from './EditorContext';
import { type UseFormReturnType } from '@mantine/form';

// Provider component props
export interface EditorProviderProps<TFormType> {
    children: ReactNode;
    form: UseFormReturnType<TFormType>;
    onSave: () => Promise<boolean | void>;
    loading: boolean;
    mode: 'create' | 'update';
}

// Provider component
export const EditorProvider = <TFormType,>({
    children,
    form,
    onSave,
    loading,
    mode,
}: EditorProviderProps<TFormType>) => {
    const contextValue: EditorContextValue<TFormType> = {
        form,
        onSave,
        loading,
        mode,
    };

    return <EditorContext.Provider value={contextValue}>{children}</EditorContext.Provider>;
};
